import React from 'react'
import { useStats } from '../hooks/useStats'
import TrafficChart from '../components/TrafficChart'
import ChaptersChart from '../components/ChaptersChart'

const StatsPage: React.FC = () => {
  const { dailyTraffic, chapterStats, rawData, isLoading, error } = useStats()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#F3F2EF] flex items-center justify-center">
        <div className="text-xl text-gray-600">Ładowanie danych...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#F3F2EF] flex items-center justify-center">
        <div className="text-xl text-red-600">{error}</div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#F3F2EF] py-8 px-4 md:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-apropal text-[32px] md:text-[48px] text-black font-bold mb-8">
          Statystyki
        </h1>

        <div className="space-y-8">
          <TrafficChart data={dailyTraffic} rawData={rawData} />
          <ChaptersChart data={chapterStats} />
        </div>
      </div>
    </div>
  )
}

export default StatsPage
